import React from 'react';
import { Paragraph } from '../../Typography';
function SortLabel(_a) {
    var children = _a.children, id = _a.id;
    return (React.createElement(Paragraph, { className: "elmo-sort__label p-3 pl-5 ml-2", size: "sm", "data-testid": "elmo-sort-label-" + (id || 'default') }, children));
}
export default SortLabel;
